import React from 'react';
import classnames from 'classnames';
import { HotelResult } from 'services/BackendApi';

export enum EAvailabilityTagStatus {
  AVAILABLE,
  UNAVAILABLE,
  REQUEST,
  PLAIN,
  INSTANT_BOOK,
}

interface IAvailabilityTagProps {
  className: string;
  availabilityStatus: EAvailabilityTagStatus | 'Available' | 'Unavailable' | 'On Request' | 'Partially Available';
  children: any;
}
export const AvailabilityTag = (props: IAvailabilityTagProps) => {
  const { className, availabilityStatus, children } = props;
  return (
    <span
      style={{
        padding: '2px 5px',
      }}
      className={classnames(
        `${className} text-black font-hurmegeometric-sans text-xs leading-14px tracking-2xs rounded-1px not-italic font-normal`,
        {
          'bg-teal-30':
            availabilityStatus === EAvailabilityTagStatus.AVAILABLE ||
            availabilityStatus === EAvailabilityTagStatus.INSTANT_BOOK ||
            availabilityStatus === 'Available',
          'bg-red-30':
            availabilityStatus === EAvailabilityTagStatus.UNAVAILABLE || availabilityStatus === 'Unavailable',
          'bg-yellow-40': availabilityStatus === EAvailabilityTagStatus.REQUEST || availabilityStatus === 'On Request',
          'bg-white':
            availabilityStatus === EAvailabilityTagStatus.PLAIN || availabilityStatus === 'Partially Available',
        }
      )}
    >
      {children}
    </span>
  );
};
